<div class="footer">
  Version:<br /><a routerLink="/version">{{version}}</a>
</div>
